<section class="flex flex-col gap-2">
  <div class="flex justify-between items-center w-full">
    <h3 class="text-2xl lg:text-3xl font-semibold">Similar Listings</h3>
    <button
      *ngIf="!isLoading && listings.length > 0"
      [routerLink]="'/used-tesla-for-sale'"
      [queryParams]="{
        OrderBy: 'created DESC',
        model: previousModel,
        Skip: 0,
        Top: 9
      }"
      class="border-2 !border-OUT-Blue rounded-full px-4 py-1.5 text-OUT-Blue font-semibold w-fit hover:bg-OUT-Blue hover:text-white transition-colors duration-400 cursor-pointer"
    >
      View More
    </button>
  </div>

  <div
    *ngIf="!isLoading"
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 xl:gap-x-7"
  >
    <span *ngFor="let listing of listings">
      <out-listing-card [listing]="listing"></out-listing-card>
    </span>
  </div>
  <div
    *ngIf="isLoading"
    class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 xl:gap-x-7"
  >
    <span *ngFor="let placeholders of placeholderSkeletons">
      <out-listing-skeleton></out-listing-skeleton>
    </span>
  </div>
  <div class="text-center py-28 text-gray-500" *ngIf="listings.length === 0 && !isLoading">
    <h4 class="text-lg 2xl:text-xl font-medium">
      No similar listings found.
    </h4>
    <a
      [routerLink]="'/used-tesla-for-sale'"
      [queryParams]="{
        OrderBy: 'created DESC',
        Skip: 0,
        Top: 9
      }"
      class="rounded-full bg-OUT-Blue font-semibold hover:bg-OUT-Blue/90 transition-colors duration-300 px-6 py-2 text-white mt-3 inline-block cursor-pointer"
      >View Listings</a
    >
  </div>
</section>
